import normalizeBoards from "../../server/fetchBoardData";

type Board = {
  _id: string;
  title: string;
  lists: string[];
  users: string[];
  color: string;
};

type BoardsByIdState = Record<string, Board>;

type BoardsByIdAction =
  | { type: "SET_BOARDS"; payload: any[] }
  | { type: "SET_BOARD"; payload: Board }
  | { type: "ADD_LIST"; payload: { boardId: string; listId: string } }
  | { type: "MOVE_LIST"; payload: { oldListIndex: number; newListIndex: number; boardId: string } }
  | { type: "DELETE_LIST"; payload: { listId: string; boardId: string } }
  | { type: "ADD_BOARD"; payload: { boardTitle: string; boardId: string; userId: string } }
  | { type: "CHANGE_BOARD_TITLE"; payload: { boardTitle: string; boardId: string } }
  | { type: "CHANGE_BOARD_COLOR"; payload: { boardId: string; color: string } }
  | { type: "DELETE_BOARD"; payload: { boardId: string } };

const boardsById = (state: BoardsByIdState = {}, action: BoardsByIdAction): BoardsByIdState => {
  switch (action.type) {
    case "SET_BOARDS": {
      console.log("🔵 boardsById reducer - SET_BOARDS action payload:", action.payload);
      const normalized = normalizeBoards(action.payload);
      console.log("🟢 boardsById reducer - Normalized boards:", normalized.boardsById);
      console.log("📊 boardsById reducer - Board IDs:", Object.keys(normalized.boardsById || {}));
      return {
        ...normalized.boardsById
      };
    }
    case "SET_BOARD": {
      const boardId = action.payload._id;
      return {
        ...state,
        [boardId]: {
          ...action.payload
        }
      };
    }
    case "ADD_LIST": {
      const { boardId, listId } = action.payload;
      return {
        ...state,
        [boardId]: {
          ...state[boardId],
          lists: [...state[boardId].lists, listId]
        }
      };
    }
    case "MOVE_LIST": {
      const { oldListIndex, newListIndex, boardId } = action.payload;
      const newLists = Array.from(state[boardId].lists);
      const [removedList] = newLists.splice(oldListIndex, 1);
      newLists.splice(newListIndex, 0, removedList);
      return {
        ...state,
        [boardId]: { ...state[boardId], lists: newLists }
      };
    }
    case "DELETE_LIST": {
      const { listId: newListId, boardId } = action.payload;
      return {
        ...state,
        [boardId]: {
          ...state[boardId],
          lists: state[boardId].lists.filter(listId => listId !== newListId)
        }
      };
    }
    case "ADD_BOARD": {
      const { boardTitle, boardId, userId } = action.payload;
      return {
        ...state,
        [boardId]: {
          _id: boardId,
          title: boardTitle,
          lists: [],
          users: [userId],
          color: "blue"
        }
      };
    }
    case "CHANGE_BOARD_TITLE": {
      const { boardTitle, boardId } = action.payload;
      return {
        ...state,
        [boardId]: {
          ...state[boardId],
          title: boardTitle
        }
      };
    }
    case "CHANGE_BOARD_COLOR": {
      const { boardId, color } = action.payload;
      return {
        ...state,
        [boardId]: {
          ...state[boardId],
          color
        }
      };
    }
    case "DELETE_BOARD": {
      const { boardId } = action.payload;
      const { [boardId]: deletedBoard, ...restOfBoards } = state;
      return restOfBoards;
    }
    default:
      return state;
  }
};

export default boardsById;
